/**
 * Duplicate of the processing console whose centre visual is a three.js scene
 * instead of the 2D canvas orbit. Everything else - pipeline strip, stage log,
 * live yield, coverage gauges - is the same shell driven by the same run.
 */
import { ConsoleShell } from "./ConsoleShell";
import { PipelineScene3D } from "./PipelineScene3D";
import { usePipelineRun } from "./processingPipeline";
import type { ProcessingConsoleProps } from "./ProcessingConsole";

export function ProcessingConsole3D({
  fileName,
  fileSize,
  documentTitle,
  documentType,
  phase,
  result = null,
  errorMessage = null,
  onCancel,
  onFinished,
  topBarExtra,
  notice,
  footer,
  onMinimize,
  apiDurationMs = null,
  inline,
}: ProcessingConsoleProps) {
  const run = usePipelineRun(
    phase,
    onFinished,
    apiDurationMs ?? result?.durationMs ?? null,
    result?.sevenLayerValidation?.clearedLayers ?? null,
  );

  return (
    <ConsoleShell
      fileName={fileName}
      fileSize={fileSize}
      documentTitle={documentTitle}
      documentType={documentType}
      phase={phase}
      run={run}
      result={result}
      errorMessage={errorMessage}
      onCancel={onCancel}
      topBarExtra={topBarExtra}
      notice={notice}
      footer={footer}
      onMinimize={onMinimize}
      inline={inline}
      variantLabel="3D scene"
      core={<PipelineScene3D run={run} />}
    />
  );
}
